import React from "react";
import {Radio} from "antd";

export default class NumberRadioShow extends React.Component{
    constructor(props) {
        super(props);

        this.state = {}
    }

    render(){
        let contentMsg = this.props.contentMsg;
        let {contentParams,parameterValue} = contentMsg.dataConfig;

        if(!contentParams){
            return null
        }

        let options = [];
        if(contentParams.listSpecial?.length){
            let vs = contentParams.listSpecial.filter((item)=>{
                return !!item.label
            })
            options = options.concat(vs)
        }


        return <div
            style={{width: "100%",
                display: "flex",
                alignItems: "center",
            }}
        >
            {
                contentParams.label
                    ?<span>{contentParams.label}</span>
                    :null
            }
            <div
                style={{flex: 1}}
            >
                <Radio.Group
                    {...contentParams.selectOption}
                    defaultValue={parameterValue}
                    options={options}
                    onChange={(e)=>{
                        this.props.valueChanged?.(e.target.value,parameterValue)
                    }}
                >

                </Radio.Group>
            </div>
        </div>
    }
}